import { render } from "./ArchiveProjectModal.vue?vue&type=template&id=2cedc8b2&scoped=true"
import script from "./ArchiveProjectModal.vue?vue&type=script&lang=js"
export * from "./ArchiveProjectModal.vue?vue&type=script&lang=js"

import "./ArchiveProjectModal.vue?vue&type=style&index=0&id=2cedc8b2&lang=scss&scoped=true"

import exportComponent from "/home/developer/public_html/admin.cureline-crm.cureline.com/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2cedc8b2"]])

export default __exports__